module.exports = __webpack_public_path__ + "static/media/Agenda14.dbacfdae.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/Agenda/Agenda14.png
// module id = 1979
// module chunks = 0